import { httpClient } from '@/services/http/httpClient'

export type CreateSubCommentVideoParams = {
  text: string
  commentId: string
}

export async function createSubComment({
  text,
  commentId,
}: CreateSubCommentVideoParams) {
  return await httpClient.post('/users/videos/comments/replies', {
    text,
    commentId,
  })
}
